"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasRenderer = void 0;

var React = _interopRequireWildcard(require("react"));

var _canvasUtils = require("../canvas-utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CanvasRenderer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CanvasRenderer, _React$Component);

  function CanvasRenderer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CanvasRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CanvasRenderer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "ctx", void 0);

    _defineProperty(_assertThisInitialized(_this), "canvas", void 0);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.canvas !== null) {
        // Assign canvas to local variable to work around a flow refinement invalidation.
        // https://flow.org/en/docs/lang/refinements/#toc-refinement-invalidations
        var canvas = _this.canvas;
        _this.ctx = (0, _canvasUtils.getCanvasContext)(canvas);

        _this.draw(canvas);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      if (_this.canvas !== null) {
        _this.draw(_this.canvas);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "draw", function (canvasElement) {
      var radius = function radius(radiusProportion) {
        return Math.min(width, height) / 2 * radiusProportion;
      };

      var rect = canvasElement.getBoundingClientRect();
      var width = rect.width;
      var height = rect.height;
      var x = width * 0.5;
      var y = height * 0.5;
      var lineWidth = radius(_this.props.ringThickness);
      var ringInner = radius(1 - _this.props.ringThickness);
      var ringOuter = radius(1);
      var step = Math.floor(_this.props.steps * _this.props.proportion); // Clear the canvas

      _this.ctx.clearRect(0, 0, width, height); // Draw the background circle


      if (_this.props.backgroundTransparent === false) {
        (0, _canvasUtils.drawSegment)(_this.ctx, x, y, ringOuter, 0, 360);
        _this.ctx.fillStyle = _this.props.backgroundColour;

        _this.ctx.fill();
      }

      if (_this.props.segmented) {
        for (var i = 0; i < _this.props.steps; i++) {
          var startAngle = i / _this.props.steps * 360;
          var endAngle = (i + 1) / _this.props.steps * 360;
          var strokeStyle = i < step ? _this.props.ringFgColour : _this.props.ringBgColour;
          (0, _canvasUtils.drawStrokeSegment)(_this.ctx, x, y, startAngle + _this.props.segmentGap / 2, endAngle - _this.props.segmentGap / 2, ringInner, ringOuter, strokeStyle);
        }
      } else {
        var _endAngle = step / _this.props.steps * 360;

        (0, _canvasUtils.drawStrokeSegment)(_this.ctx, x, y, 0, 360, ringInner, ringOuter, _this.props.ringBgColour);
        (0, _canvasUtils.drawStrokeSegment)(_this.ctx, x, y, 0, _endAngle, ringInner, ringOuter, _this.props.ringFgColour);
      } // Draw the 'intermediate progress' ring


      if (_this.props.showIntermediateProgress === true) {
        var total = 360;
        var segmentOffset = 0;

        if (_this.props.segmented === true) {
          total = 360 - _this.props.steps * _this.props.segmentGap;
          segmentOffset = step * _this.props.segmentGap + _this.props.segmentGap / 2;
        }

        var _startAngle = step / _this.props.steps * total;

        var _endAngle2 = total * _this.props.proportion;

        (0, _canvasUtils.drawStrokeSegment)(_this.ctx, x, y, _startAngle + segmentOffset, _endAngle2 + segmentOffset, ringInner, ringOuter, _this.props.ringIntermediateColour);
      }
    });

    return _this;
  }

  _createClass(CanvasRenderer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("canvas", {
        ref: function ref(_ref) {
          return _this2.canvas = _ref;
        },
        style: {
          width: '100%',
          height: '100%'
        }
      });
    }
  }]);

  return CanvasRenderer;
}(React.Component);

exports.CanvasRenderer = CanvasRenderer;

_defineProperty(CanvasRenderer, "defaultProps", {
  backgroundColour: '#fff',
  backgroundTransparent: true,
  proportion: 0,
  ringBgColour: '#ccc',
  ringFgColour: '#3c763d',
  ringIntermediateColour: '#aaa',
  ringThickness: 0.2,
  showIntermediateProgress: false,
  segmented: true,
  segmentGap: 2,
  steps: 360
});